module.exports = __webpack_public_path__ + "static/media/chimney.4fb7e883.svg";